<template>
  <l-modal @close="() => $emit('close')" :show-close="false" backdrop-closable>
    <div class="flex flex-col items-center mt-4 gap-4 text-n-0">
      <h1 class="heading-2">
        {{ t(`employees.attendance.${type}`) }}
      </h1>
      <div class="font-medium flex flex-col items-center">
        <span>{{ employee.name }}</span>
        <span> {{ formattedNow }} </span>
      </div>
      <pin-pad v-model="pin" :wrong-value="error" />
    </div>
    <template #footer>
      <div class="flex justify-center w-full gap-2 px-16">
        <l-button class="w-1/2" @click="onBack">
          {{ t('ctas.back') }}
        </l-button>
        <l-button class="w-1/2" @click="checkPinAndProceed">
          {{ t(`employees.attendance.${type}`) }}
        </l-button>
      </div>
    </template>
  </l-modal>
</template>

<script setup lang="ts">
import { useNow } from '@vueuse/core'
import { format } from 'date-fns'
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { LButton, LModal } from '@last/core-ui/paprika'

import PinPad from '@/components/PinPad.vue'
import { useEmployeeStore } from '@/store/employee'
import type { Employee } from '@/types'

const { t } = useI18n()

type Props = {
  employee: Employee
  type: 'clock-in' | 'clock-out'
}

const props = defineProps<Props>()

const employeeStore = useEmployeeStore()
const { saveAttendance, safeSelectEmployee } = employeeStore
const { clockingEmployee, isAttendanceMode } = storeToRefs(employeeStore)

const now = useNow()
const pin = ref<string>('')
const error = ref<boolean>(false)

const formattedNow = computed(() => format(now.value, 'dd/MM - hh:mm:ss'))

const emit = defineEmits<{
  close: []
  done: [Employee]
}>()

function checkPin() {
  if (pin.value.length !== 4) return false

  return pin.value === props.employee.accessPin
}

function checkPinAndProceed() {
  if (!checkPin()) error.value = true
  else {
    error.value = false
    const currentEmployee = props.employee
    saveAttendance({
      employee: currentEmployee,
      type: props.type
    })

    if (props.type === 'clock-in' && props.employee.posAccess) {
      safeSelectEmployee(props.employee)
    } else {
      emit('close')
    }

    isAttendanceMode.value = false
  }
}

function onBack(): void {
  clockingEmployee.value = undefined
  emit('close')
}
</script>
